import { IClaimRequest } from "./model/claim.model";
import { BehavioralService } from "./service/behavioral.service";
import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { IClaimResponse } from "./model/claim.model";
import { ISetUpPasswordRequest } from "./model/setUpPassword.model";
import { SetUpPasswordService } from "./service/setUpPassword.service";
import {
  IQuestionAnswer,
  IQuestionAnswerArray,
} from "./model/question.answer.model";

@Component({
  templateUrl: "./template/setUpPassword.component.html",
  styles: [
    `
      em {
        float: right;
        color: #e05c65;
        padding-left: 10px;
      }
    `,
  ],
})
export class SetUpPasswordComponent implements OnInit, OnDestroy {
  registerForm: UntypedFormGroup;
  submitted = false;
  questionAnswerArray: IQuestionAnswer[];
  claim: IClaimResponse;
  claimRequest: IClaimRequest;
  $subs: Subscription;
  setUpPasswordRequest: ISetUpPasswordRequest;
  errorResponse;
  new_passwordShow = false;
  passwordShow = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private behavioralService: BehavioralService,
    private setUpPasswordService: SetUpPasswordService
  ) {}

  ngOnDestroy(): void {
    this.$subs.unsubscribe();
  }
  ngOnInit() {
    this.$subs = this.behavioralService.receiveQAList().subscribe((d) => {
      this.questionAnswerArray = d;

      /* [
        {
            "question": "What is your mother's maiden name?",
            "id": "ac1b0e5e7939141581793954fa28000e",
            "answer": "hola"
        },
        {
            "question": "What is your favorite color?",
            "id": "ac1b0e5e7939141581793954fa32000f",
            "answer": "de nuevo"
        },
        {
            "question": "What is the name of the first street you lived on?",
            "id": "ac1b0e5e7939141581793954fa3c0010",
            "answer": "soy yo"
        }
    ]*/
    });

    this.$subs = this.behavioralService.receiveClaimData().subscribe((d) => {
      this.claim = d;
      /*{
        "status": "Valid",
        "errors": "",
        "raw_value": "{Status=Valid, UserName=anh.testworkday, errors=}",
        "user_name": "anh.testworkday"
      }*/
    });

    this.$subs = this.behavioralService
      .receiveClaimRequestData()
      .subscribe((d) => {
        this.claimRequest = d;
        /*{
        "first_name": "Anh",
        "last_name": "TestWorkday",
        "claim_code": "511855252",
        "user_type": "employee"
      }*/
      });

    this.registerForm = this.formBuilder.group(
      {
        email: ["", [Validators.required, Validators.email]],
        password: ["", [Validators.required, Validators.minLength(12)]],
        new_password: ["", Validators.required],
      },
      {
        validator: [General(), MustMatch("password", "new_password")],
      }
    );
  }

  get f() {
    return this.registerForm.controls;
  }

  onSubmit() {
    if (this.registerForm.invalid) {
      return;
    }
    let request = this.buildPasswordRequest();
    this.setUpPasswordService.postPasswordData(request).subscribe((resp) => {
      //console.log("Response of SetUp Password", resp)
      if (resp.status == "Valid") {
        this.router.navigate(["identityiq/external/success"]);
      } else {
        this.errorResponse = resp.errors;
      }
    });
    this.submitted = true;
  }

  buildPasswordRequest(): ISetUpPasswordRequest {
    let request: ISetUpPasswordRequest = {
      first_name: this.claimRequest.first_name,
      last_name: this.claimRequest.last_name,
      claim_code: this.claimRequest.claim_code,
      user_type: this.claimRequest.user_type,
      user_name: this.claim.user_name,

      password: this.registerForm.get("password").value,
      personal_email: this.registerForm.get("email").value,
      security_questions: this.questionAnswerArray,
    };
    //console.log('Request',request)
    return request;
  }

  toggle(str: string) {
    if (str === "passwordShow") {
      const password = document.querySelector("#password");
      const type =
        password.getAttribute("type") === "password" ? "text" : "password";
      password.setAttribute("type", type);
      this.passwordShow = !this.passwordShow;
    }

    if (str === "new_passwordShow") {
      const password = document.querySelector("#new_password");
      const type =
        password.getAttribute("type") === "password" ? "text" : "password";
      password.setAttribute("type", type);

      this.new_passwordShow = !this.new_passwordShow;
    }
  }
}

export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: UntypedFormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}

export function General() {
  return (formGroup: UntypedFormGroup) => {
    const control = formGroup.controls["password"];

    if (control.errors && !control.errors.general) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (
      control.value.match(/[A-Z]/) && // at least 1 upper case letter
      control.value.match(/[a-z]/) && // at least 1 lower case letter
      control.value.match(/[0-9]/) // at least 1 digit
      //&& !input.match(/\s/)   // no whitespace
    ) {
      control.setErrors(null);
    } else {
      control.setErrors({ general: true });
    }
  };
}
